import {use} from 'react';
import {ArrTabFocusContext} from './ArrTabFocusProvider';

export const useArrTabFocus = () => {
  const context = use(ArrTabFocusContext);

  return context;
};

export default useArrTabFocus;
